import driver from '@/page/driver/driver';
import login from '@/page/user/login';
import myDelivery from '@/page/driver/my-delivery';
import createDelivery from '@/page/driver/create-delivery';
import deliveryDetail from '@/page/driver/delivery-detail';
import newDelivery from '@/page/driver/new-delivery';
import mine from '@/page/home/mine';
import driverInfo from '@/page/driver/driver-info';
import feedback from '@/page/home/feedback';
import favorite from '@/page/home/favorite';
import driverSupplier from '@/page/driver/driver-supplier';
import driverRegister from '@/page/driver/driver-register';
import driverManage from '@/page/driver/driver-manage';
export default [
  {
    path:'/driver',
    component:driver,
    name:'driver',
    children:[
      {
        path:'login',
        component:login,
        meta:{
          title:'登录',
          driver:true
        }
      },
      {
        path:'my-delivery',
        component:myDelivery,
        meta:{
          title:'我的送货',
          driver:true
        }
      },
      {
        path:'delivery-detail/:id',
        component:deliveryDetail,
        meta:{
          title:'送货单详情',
          driver:true
        }
      },
      {
        path:'create-delivery',
        component:createDelivery,
        meta:{
          title:'创建送货单',
          driver:true
        }
      },
      {
        path:'new-delivery/:orderNo',
        component:newDelivery,
        meta:{
          title:'创建送货单',
          driver:true
        }
      },
      {
        path:'new-delivery/:orderNo/:codeType',
        component:newDelivery,
        meta:{
          title:'创建送货单',
          driver:true
        }
      },
      {
        path:'mine',
        component:mine,
        meta:{
          title:'个人资料',
          driver:true
        }
      },
      {
        path:'personal-info',
        component:driverInfo,
        meta:{
          title:'个人详情',
          driver:true
        }
      },
      {
        path:'driver-supplier/:tel',
        component:driverSupplier,
        meta:{
          title:'绑定发货方',
          driver:true
        }
      },
      {
        path:'feedback',
        component:feedback,
        meta:{
          title:'个人资料',
          driver:true
        }
      },
      {
        path:'favorite',
        component:favorite,
        meta:{
          title:'设置',
          driver:true
        }
      },
      {
        path:'register',
        component:driverRegister,
        meta:{
          title:'注册',
          driver:true
        }
      },
    ],
    meta:{
      title:'司机协同',
      driver:true
    }
  },
  {
    path:'/driver-manage',
    component:driverManage,
    meta:{
      name:'司机管理'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/driver.js